import { FormControl, Validators } from '@angular/forms';
import { ServiceAddon } from '../models/service-addon';

export class ServiceAddonForm {
	uuid = new FormControl();
	id = new FormControl();
	name = new FormControl('', [Validators.required]);
	name_ar = new FormControl();
	price = new FormControl(0, [Validators.required, Validators.max(99000000)]); 

	constructor(addons: ServiceAddon) {
		if (addons.uuid)
			this.uuid.setValue(addons.uuid);

		this.name.setValue(addons.name);
		this.name_ar.setValue(addons.name_ar);
		this.price.setValue(addons.price);
	}
}
